import type { ResourceKind } from '../types';

export const resourceColors: Record<ResourceKind, string> = {
  Eisen: '#9aa8ae',
  Kupfer: '#e27d47',
  Kalkstein: '#d9d3bd',
  Kohle: '#414947',
  Caterium: '#f2c84b',
  Schwefel: '#d5e245',
  Quarz: '#c9b8ef',
  Bauxit: '#bd6555',
  Uran: '#67d86d',
  SAM: '#a86ff1',
  Rohöl: '#756375',
  Wasser: '#4b9bc0',
  Stickstoff: '#9dcbd9',
  Geysir: '#e58d63',
};
